import React from "react";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { BooleanDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { DateDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/DateDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { FileDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/FileDataDefinition";
import { StoryNode } from "../StoryBook/StoryData";
import { DataTypePicker } from "./DataTypePicker";

export const DataTypePickerStories = [
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        variant={"minimal"}
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Minimal",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        variant={"header"}
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Header",
    ),

    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        label={"Result"}
                        variant={"minimal"}
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Minimal - label",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        label={"Result"}
                        variant={"header"}
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Header - label",
    ),

    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "String",
    ),

    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        label={"Result"}
                        hint={"hint"}
                        dataDef={new StringDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "String - label + hint",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new BooleanDataDefinition("string")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Boolean",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new DateDataDefinition("date")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Date",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new NumberDataDefinition("number")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Number",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new ObjectDataDefinition("object")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "Object",
    ),
    new StoryNode(
        () => {
            return (
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 250 }}>
                    <DataTypePicker
                        dataDef={new FileDataDefinition("file")}
                        updateCallback={() => {}}
                    />
                </div>
            );
        },
        "Shared",
        "Data Type Picker",
        "File",
    ),
];
